import ConversationApi from 'dashboard/api/conversations';

// Distinct values that populate the Claudia-mirror Advanced Filters dropdowns
// (ab_key / resolution_reason / topic / flow_session_id / used_sections).
// Options are fetched lazily the first time a field's dropdown is opened and
// cached per field for the rest of the session — the source data changes slowly
// and the modal re-reads the getter on every render.

export const state = {
  // { [field]: [{ id, name }] }
  records: {},
  // { [field]: true } while an in-flight request is pending, so we do not
  // fire duplicate requests for the same field.
  fetching: {},
};

export const getters = {
  getOptions: $state => field => $state.records[field] || [],
  isFetching: $state => field => Boolean($state.fetching[field]),
};

export const actions = {
  // Fetch once per field. Subsequent calls are a no-op if the field is already
  // loaded or currently loading.
  fetch: async ({ commit, state: $state }, field) => {
    if ($state.records[field] || $state.fetching[field]) {
      return;
    }
    commit('SET_FETCHING', { field, value: true });
    try {
      const response = await ConversationApi.getFilterOptions(field);
      commit('SET_OPTIONS', { field, options: response.data });
    } catch (error) {
      // Leave the field unset so a later open can retry; the dropdown simply
      // renders empty until then. Log so the failure is not swallowed silently.
      // eslint-disable-next-line no-console
      console.error(`Failed to load filter options for "${field}"`, error);
    } finally {
      commit('SET_FETCHING', { field, value: false });
    }
  },
};

export const mutations = {
  SET_OPTIONS($state, { field, options }) {
    $state.records = { ...$state.records, [field]: options };
  },
  SET_FETCHING($state, { field, value }) {
    $state.fetching = { ...$state.fetching, [field]: value };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
